<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  provide(){
    return {
        reload: this.reload
    }
    },
  data(){
    return {
        isRouterAlive:true
    }
  },
  methods:{
    reload(){
        this.isRouterAlive=false
        this.$nextTick(()=>this.isRouterAlive=true)
    }
  },
  
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      // this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
      // if (!this.$store.state.isLogin){
      //     this.$router.push("/login");
      // }
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  },

  beforeUpdate() {
    var domain = document.domain
    var path = this.$route.name
    document.title = domain + ' | ' + path
  },
}
</script>

<style>
body {
  margin: 0 auto;
}

#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
textarea {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', '\5FAE\8F6F\96C5\9ED1', Arial, sans-serif;
}
.eloption .el-select-dropdown__wrap {
  max-height: 500px !important;
}
</style>
